import React from 'react';
import MobileDevPageSide300x250Gak from './gak/MobileDevPageSide300x250';
const MobileDevPageSide300x250 = ({ safety ='off'  })=>{
    return /*#__PURE__*/ React.createElement(MobileDevPageSide300x250Gak, {
        safety: safety
    });
};
MobileDevPageSide300x250.displayName = 'MobileDevPageSide300x250';
export default MobileDevPageSide300x250;
